<script setup>
// --------------------------------- Imports -------------------------------- //
import { useCommonImports } from '~/common/composables/common-imports.composable.js';

// ---------------------------------- Props --------------------------------- //
defineProps({
  filterConfig: {
    type: Object,
    default: () => ({}),
  },
});
// ---------------------------------- Emits --------------------------------- //

// ---------------------------- Injects/Provides ---------------------------- //

// ----------------------- Variables - Pinia - consts ----------------------- //
const {
  $t,
} = useCommonImports();
// --------------------- Variables - Pinia - storeToRefs -------------------- //

// ------------------- Variables - Local - consts and lets ------------------ //
const date_bins = [{ label: $t('Day'), value: 'day' }, { label: $t('Week'), value: 'week' }, { label: $t('Month'), value: 'month' }, { label: $t('Quarter'), value: 'quarter' }, { label: $t('Year'), value: 'year' }];
// ------------------------ Variables - Local - refs ------------------------ //

// ---------------------- Variables - Local - reactives --------------------- //

// --------------------------- Computed properties -------------------------- //

// -------------------------------- Functions ------------------------------- //

// -------------------------------- Watchers -------------------------------- //

// ----------------------------- Lifecycle Hooks ---------------------------- //
</script>

<template>
  <div>
    <SelectElement
      name="operator_value"
      :default="filterConfig?.operator_value || 'week'"
      :can-clear="false"
      :can-deselect="false"
      :native="false"
      :items="date_bins"
    />
  </div>
</template>
